var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var showNotice = function (type, message) {
    if (type === void 0) { type = 'add'; }
    var tone = type === 'error' ? 'error' : 'success';
    var text = 'Produkt wurde in den Warenkorb gelegt.';
    if (type === 'copy') {
        text = 'Link in die Zwischenablage kopiert.';
    }
    else if (type === 'error') {
        text = message || 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
    }
    var options = type === 'add'
        ? {
            actionLabel: 'Warenkorb öffnen',
            onAction: function () {
                return document.body.dispatchEvent(new CustomEvent('openMiniCart', { bubbles: true }));
            },
        }
        : undefined;
    var siteWindow = window;
    if (siteWindow.SMToast && typeof siteWindow.SMToast[tone] === 'function') {
        siteWindow.SMToast[tone](text, options);
        return;
    }
    document.dispatchEvent(new CustomEvent('sm:toast', { detail: __assign({ message: text, tone: tone }, options) }));
};
